import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  AsesmenDentalKhusus,
  FotoKategori,
  OhisData,
} from "@/types/asesmen_dental_khusus";

interface SavePayload {
  register_id: string;
  pasien_rm: number | string;
  tgl_periksa: string;
  ohis: OhisData;
  catatan: string | null;
  dokter_id: number;
  user_id: number;
}

class DataAsesmenDentalKhusus {
  async getByRegister(register_id: string): Promise<AsesmenDentalKhusus | null> {
    try {
      const res = await http.getData(`/asesmen-dental-khusus/register/${register_id}`);
      return res?.data?.data ?? null;
    } catch (e) {
      ErrorAlert.showSnackAlert(e, "Asesmen Dental Khusus by Register");
      return null;
    }
  }

  async save(payload: SavePayload): Promise<AsesmenDentalKhusus | null> {
    try {
      const res = await http.postData(`/asesmen-dental-khusus`, payload);
      return res?.data?.data ?? null;
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
      return null;
    }
  }

  async update(id: number, payload: SavePayload): Promise<AsesmenDentalKhusus | null> {
    try {
      const res = await http.putData(`/asesmen-dental-khusus/${id}`, payload);
      return res?.data?.data ?? null;
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
      return null;
    }
  }

  async uploadFoto(
    id: number,
    file: File,
    meta: { kategori: FotoKategori; view?: string; catatan?: string; taken_at?: string }
  ) {
    try {
      const form = new FormData();
      form.append("file", file);
      form.append("kategori", meta.kategori);
      if (meta.view) form.append("view", meta.view);
      if (meta.catatan) form.append("catatan", meta.catatan);
      if (meta.taken_at) form.append("taken_at", meta.taken_at);
      const res = await http.postData(`/asesmen-dental-khusus/${id}/foto`, form);
      return res?.data?.data ?? null;
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
      return null;
    }
  }

  async deleteFoto(id: number, fotoId: number): Promise<boolean> {
    try {
      await http.deleteData(`/asesmen-dental-khusus/${id}/foto/${fotoId}`);
      return true;
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
      return false;
    }
  }

  pdfUrl(id: number): string {
    return `${http.getAPI()}/asesmen-dental-khusus/${id}/pdf`;
  }
}

export default new DataAsesmenDentalKhusus();
